// extracted by mini-css-extract-plugin
module.exports = {"Panel":"css-modules_Panel__R3mkV","Button":"css-modules_Button__8BBfy","Icon":"css-modules_Icon__c78QR"};